import * as types from './actionTypes';
import {LiveTrackingService} from "./liveTrackingService";

export function getCurrentOrders(accessToken) {
  return dispatch => {
    return LiveTrackingService.current(accessToken)
      .then(result => {
          return dispatch(dispatchLiveTrackingData(result));
      })
      .catch(error => {
        throw(error);
      })
  }
}

function dispatchLiveTrackingData(liveTrackingData) {
  return {type: types.LIVE_TRACKING_DATA, liveTrackingData: liveTrackingData}
}


// WEBPACK FOOTER //
// ./src/service/liveTrackingActions.js